"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_query_operation_1 = require("@comunica/bus-query-operation");
/**
 * A comunica Slice Query Operation Actor.
 */


var ActorQueryOperationSlice =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationSlice, _bus_query_operation_);

  function ActorQueryOperationSlice(args) {
    _classCallCheck(this, ActorQueryOperationSlice);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationSlice).call(this, args, 'slice'));
  }

  _createClass(ActorQueryOperationSlice, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(pattern, context) {
        var output, hasLength, bindingsStream, metadata;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = bus_query_operation_1.ActorQueryOperation;
                _context2.next = 3;
                return this.mediatorQueryOperation.mediate({
                  operation: pattern.input,
                  context: context
                });

              case 3:
                _context2.t1 = _context2.sent;
                output = _context2.t0.getSafeBindings.call(_context2.t0, _context2.t1);
                // Slice the bindings stream
                hasLength = !!pattern.length || pattern.length === 0;
                bindingsStream = output.bindingsStream.range(pattern.start, hasLength ? pattern.start + pattern.length - 1 : Infinity); // If we find metadata, apply slicing on the total number of items

                metadata = !output.metadata ? null : function () {
                  return output.metadata().then(function (subMetadata) {
                    var totalItems = subMetadata.totalItems;

                    if (isFinite(totalItems)) {
                      totalItems = Math.max(0, totalItems - pattern.start);

                      if (hasLength) {
                        totalItems = Math.min(totalItems, pattern.length);
                      }
                    }

                    return Object.assign({}, subMetadata, {
                      totalItems: totalItems
                    });
                  });
                };
                return _context2.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: bindingsStream,
                  metadata: metadata,
                  variables: output.variables
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function runOperation(_x3, _x4) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }]);

  return ActorQueryOperationSlice;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.ActorQueryOperationSlice = ActorQueryOperationSlice;